const COUNTRY_CODES = [
  { code: '+51', name: 'Perú', iso: 'PE' },
  { code: '+93', name: 'Afganistán', iso: 'AF' },
  { code: '+355', name: 'Albania', iso: 'AL' },
  { code: '+49', name: 'Alemania', iso: 'DE' },
  { code: '+376', name: 'Andorra', iso: 'AD' },
  { code: '+244', name: 'Angola', iso: 'AO' },
  { code: '+1268', name: 'Antigua y Barbuda', iso: 'AG' },
  { code: '+966', name: 'Arabia Saudita', iso: 'SA' },
  { code: '+213', name: 'Argelia', iso: 'DZ' },
  { code: '+54', name: 'Argentina', iso: 'AR' },
  { code: '+374', name: 'Armenia', iso: 'AM' },
  { code: '+297', name: 'Aruba', iso: 'AW' },
  { code: '+61', name: 'Australia', iso: 'AU' },
  { code: '+43', name: 'Austria', iso: 'AT' },
  { code: '+994', name: 'Azerbaiyán', iso: 'AZ' },
  { code: '+1242', name: 'Bahamas', iso: 'BS' },
  { code: '+973', name: 'Baréin', iso: 'BH' },
  { code: '+880', name: 'Bangladesh', iso: 'BD' },
  { code: '+1246', name: 'Barbados', iso: 'BB' },
  { code: '+501', name: 'Belice', iso: 'BZ' },
  { code: '+32', name: 'Bélgica', iso: 'BE' },
  { code: '+229', name: 'Benín', iso: 'BJ' },
  { code: '+375', name: 'Bielorrusia', iso: 'BY' },
  { code: '+95', name: 'Birmania (Myanmar)', iso: 'MM' },
  { code: '+591', name: 'Bolivia', iso: 'BO' },
  { code: '+387', name: 'Bosnia y Herzegovina', iso: 'BA' },
  { code: '+267', name: 'Botsuana', iso: 'BW' },
  { code: '+55', name: 'Brasil', iso: 'BR' },
  { code: '+673', name: 'Brunéi', iso: 'BN' },
  { code: '+359', name: 'Bulgaria', iso: 'BG' },
  { code: '+226', name: 'Burkina Faso', iso: 'BF' },
  { code: '+257', name: 'Burundi', iso: 'BI' },
  { code: '+238', name: 'Cabo Verde', iso: 'CV' },
  { code: '+855', name: 'Camboya', iso: 'KH' },
  { code: '+237', name: 'Camerún', iso: 'CM' },
  { code: '+1', name: 'Canadá / EE.UU.', iso: 'US' },
  { code: '+974', name: 'Catar', iso: 'QA' },
  { code: '+236', name: 'República Centroafricana', iso: 'CF' },
  { code: '+235', name: 'Chad', iso: 'TD' },
  { code: '+56', name: 'Chile', iso: 'CL' },
  { code: '+86', name: 'China', iso: 'CN' },
  { code: '+357', name: 'Chipre', iso: 'CY' },
  { code: '+57', name: 'Colombia', iso: 'CO' },
  { code: '+269', name: 'Comoras', iso: 'KM' },
  { code: '+242', name: 'Congo', iso: 'CG' },
  { code: '+243', name: 'Congo (RDC)', iso: 'CD' },
  { code: '+850', name: 'Corea del Norte', iso: 'KP' },
  { code: '+82', name: 'Corea del Sur', iso: 'KR' },
  { code: '+506', name: 'Costa Rica', iso: 'CR' },
  { code: '+385', name: 'Croacia', iso: 'HR' },
  { code: '+53', name: 'Cuba', iso: 'CU' },
  { code: '+45', name: 'Dinamarca', iso: 'DK' },
  { code: '+253', name: 'Yibuti', iso: 'DJ' },
  { code: '+1767', name: 'Dominica', iso: 'DM' },
  { code: '+593', name: 'Ecuador', iso: 'EC' },
  { code: '+20', name: 'Egipto', iso: 'EG' },
  { code: '+503', name: 'El Salvador', iso: 'SV' },
  { code: '+971', name: 'Emiratos Árabes Unidos', iso: 'AE' },
  { code: '+291', name: 'Eritrea', iso: 'ER' },
  { code: '+421', name: 'Eslovaquia', iso: 'SK' },
  { code: '+386', name: 'Eslovenia', iso: 'SI' },
  { code: '+34', name: 'España', iso: 'ES' },
  { code: '+372', name: 'Estonia', iso: 'EE' },
  { code: '+268', name: 'Esuatini', iso: 'SZ' },
  { code: '+251', name: 'Etiopía', iso: 'ET' },
  { code: '+63', name: 'Filipinas', iso: 'PH' },
  { code: '+358', name: 'Finlandia', iso: 'FI' },
  { code: '+679', name: 'Fiyi', iso: 'FJ' },
  { code: '+33', name: 'Francia', iso: 'FR' },
  { code: '+241', name: 'Gabón', iso: 'GA' },
  { code: '+220', name: 'Gambia', iso: 'GM' },
  { code: '+995', name: 'Georgia', iso: 'GE' },
  { code: '+233', name: 'Ghana', iso: 'GH' },
  { code: '+350', name: 'Gibraltar', iso: 'GI' },
  { code: '+30', name: 'Grecia', iso: 'GR' },
  { code: '+299', name: 'Groenlandia', iso: 'GL' },
  { code: '+1473', name: 'Granada', iso: 'GD' },
  { code: '+502', name: 'Guatemala', iso: 'GT' },
  { code: '+224', name: 'Guinea', iso: 'GN' },
  { code: '+240', name: 'Guinea Ecuatorial', iso: 'GQ' },
  { code: '+245', name: 'Guinea-Bisáu', iso: 'GW' },
  { code: '+592', name: 'Guyana', iso: 'GY' },
  { code: '+509', name: 'Haití', iso: 'HT' },
  { code: '+504', name: 'Honduras', iso: 'HN' },
  { code: '+852', name: 'Hong Kong', iso: 'HK' },
  { code: '+36', name: 'Hungría', iso: 'HU' },
  { code: '+91', name: 'India', iso: 'IN' },
  { code: '+62', name: 'Indonesia', iso: 'ID' },
  { code: '+964', name: 'Irak', iso: 'IQ' },
  { code: '+98', name: 'Irán', iso: 'IR' },
  { code: '+353', name: 'Irlanda', iso: 'IE' },
  { code: '+354', name: 'Islandia', iso: 'IS' },
  { code: '+677', name: 'Islas Salomón', iso: 'SB' },
  { code: '+972', name: 'Israel', iso: 'IL' },
  { code: '+39', name: 'Italia', iso: 'IT' },
  { code: '+1876', name: 'Jamaica', iso: 'JM' },
  { code: '+81', name: 'Japón', iso: 'JP' },
  { code: '+962', name: 'Jordania', iso: 'JO' },
  { code: '+7', name: 'Kazajistán / Rusia', iso: 'KZ' },
  { code: '+254', name: 'Kenia', iso: 'KE' },
  { code: '+996', name: 'Kirguistán', iso: 'KG' },
  { code: '+686', name: 'Kiribati', iso: 'KI' },
  { code: '+965', name: 'Kuwait', iso: 'KW' },
  { code: '+856', name: 'Laos', iso: 'LA' },
  { code: '+266', name: 'Lesoto', iso: 'LS' },
  { code: '+371', name: 'Letonia', iso: 'LV' },
  { code: '+961', name: 'Líbano', iso: 'LB' },
  { code: '+231', name: 'Liberia', iso: 'LR' },
  { code: '+218', name: 'Libia', iso: 'LY' },
  { code: '+423', name: 'Liechtenstein', iso: 'LI' },
  { code: '+370', name: 'Lituania', iso: 'LT' },
  { code: '+352', name: 'Luxemburgo', iso: 'LU' },
  { code: '+853', name: 'Macao', iso: 'MO' },
  { code: '+389', name: 'Macedonia del Norte', iso: 'MK' },
  { code: '+261', name: 'Madagascar', iso: 'MG' },
  { code: '+60', name: 'Malasia', iso: 'MY' },
  { code: '+265', name: 'Malaui', iso: 'MW' },
  { code: '+960', name: 'Maldivas', iso: 'MV' },
  { code: '+223', name: 'Malí', iso: 'ML' },
  { code: '+356', name: 'Malta', iso: 'MT' },
  { code: '+212', name: 'Marruecos', iso: 'MA' },
  { code: '+692', name: 'Islas Marshall', iso: 'MH' },
  { code: '+222', name: 'Mauritania', iso: 'MR' },
  { code: '+230', name: 'Mauricio', iso: 'MU' },
  { code: '+52', name: 'México', iso: 'MX' },
  { code: '+691', name: 'Micronesia', iso: 'FM' },
  { code: '+373', name: 'Moldavia', iso: 'MD' },
  { code: '+377', name: 'Mónaco', iso: 'MC' },
  { code: '+976', name: 'Mongolia', iso: 'MN' },
  { code: '+382', name: 'Montenegro', iso: 'ME' },
  { code: '+258', name: 'Mozambique', iso: 'MZ' },
  { code: '+264', name: 'Namibia', iso: 'NA' },
  { code: '+674', name: 'Nauru', iso: 'NR' },
  { code: '+977', name: 'Nepal', iso: 'NP' },
  { code: '+505', name: 'Nicaragua', iso: 'NI' },
  { code: '+227', name: 'Níger', iso: 'NE' },
  { code: '+234', name: 'Nigeria', iso: 'NG' },
  { code: '+47', name: 'Noruega', iso: 'NO' },
  { code: '+687', name: 'Nueva Caledonia', iso: 'NC' },
  { code: '+64', name: 'Nueva Zelanda', iso: 'NZ' },
  { code: '+968', name: 'Omán', iso: 'OM' },
  { code: '+31', name: 'Países Bajos', iso: 'NL' },
  { code: '+92', name: 'Pakistán', iso: 'PK' },
  { code: '+680', name: 'Palaos', iso: 'PW' },
  { code: '+970', name: 'Palestina', iso: 'PS' },
  { code: '+507', name: 'Panamá', iso: 'PA' },
  { code: '+675', name: 'Papúa Nueva Guinea', iso: 'PG' },
  { code: '+595', name: 'Paraguay', iso: 'PY' },
  { code: '+48', name: 'Polonia', iso: 'PL' },
  { code: '+351', name: 'Portugal', iso: 'PT' },
  { code: '+1787', name: 'Puerto Rico', iso: 'PR' },
  { code: '+44', name: 'Reino Unido', iso: 'GB' },
  { code: '+420', name: 'República Checa', iso: 'CZ' },
  { code: '+1809', name: 'República Dominicana', iso: 'DO' },
  { code: '+40', name: 'Rumanía', iso: 'RO' },
  { code: '+250', name: 'Ruanda', iso: 'RW' },
  { code: '+685', name: 'Samoa', iso: 'WS' },
  { code: '+378', name: 'San Marino', iso: 'SM' },
  { code: '+1869', name: 'San Cristóbal y Nieves', iso: 'KN' },
  { code: '+1758', name: 'Santa Lucía', iso: 'LC' },
  { code: '+239', name: 'Santo Tomé y Príncipe', iso: 'ST' },
  { code: '+1784', name: 'San Vicente y las Granadinas', iso: 'VC' },
  { code: '+221', name: 'Senegal', iso: 'SN' },
  { code: '+381', name: 'Serbia', iso: 'RS' },
  { code: '+248', name: 'Seychelles', iso: 'SC' },
  { code: '+232', name: 'Sierra Leona', iso: 'SL' },
  { code: '+65', name: 'Singapur', iso: 'SG' },
  { code: '+252', name: 'Somalia', iso: 'SO' },
  { code: '+94', name: 'Sri Lanka', iso: 'LK' },
  { code: '+27', name: 'Sudáfrica', iso: 'ZA' },
  { code: '+249', name: 'Sudán', iso: 'SD' },
  { code: '+211', name: 'Sudán del Sur', iso: 'SS' },
  { code: '+46', name: 'Suecia', iso: 'SE' },
  { code: '+41', name: 'Suiza', iso: 'CH' },
  { code: '+597', name: 'Surinam', iso: 'SR' },
  { code: '+963', name: 'Siria', iso: 'SY' },
  { code: '+992', name: 'Tayikistán', iso: 'TJ' },
  { code: '+66', name: 'Tailandia', iso: 'TH' },
  { code: '+886', name: 'Taiwán', iso: 'TW' },
  { code: '+255', name: 'Tanzania', iso: 'TZ' },
  { code: '+670', name: 'Timor Oriental', iso: 'TL' },
  { code: '+228', name: 'Togo', iso: 'TG' },
  { code: '+676', name: 'Tonga', iso: 'TO' },
  { code: '+1868', name: 'Trinidad y Tobago', iso: 'TT' },
  { code: '+216', name: 'Túnez', iso: 'TN' },
  { code: '+993', name: 'Turkmenistán', iso: 'TM' },
  { code: '+90', name: 'Turquía', iso: 'TR' },
  { code: '+688', name: 'Tuvalu', iso: 'TV' },
  { code: '+380', name: 'Ucrania', iso: 'UA' },
  { code: '+256', name: 'Uganda', iso: 'UG' },
  { code: '+598', name: 'Uruguay', iso: 'UY' },
  { code: '+998', name: 'Uzbekistán', iso: 'UZ' },
  { code: '+678', name: 'Vanuatu', iso: 'VU' },
  { code: '+58', name: 'Venezuela', iso: 'VE' },
  { code: '+84', name: 'Vietnam', iso: 'VN' },
  { code: '+967', name: 'Yemen', iso: 'YE' },
  { code: '+260', name: 'Zambia', iso: 'ZM' },
  { code: '+263', name: 'Zimbabue', iso: 'ZW' },
];

export default COUNTRY_CODES;
